import { useState } from 'react';
import { GlobalDropdownState } from '../types';

/**
 * Custom hook for managing global dropdown state
 * Ensures only one dropdown can be open across all rows
 */
export const useGlobalDropdown = () => {
  const [globalOpenDropdown, setGlobalOpenDropdown] = useState<GlobalDropdownState | null>(null);

  /**
   * Function to handle global dropdown state
   */
  const handleGlobalDropdownOpen = (rowId: string, type: 'employee' | 'role' | 'shift', isOpen: boolean) => {
    if (isOpen) {
      setGlobalOpenDropdown({ rowId, type });
    } else {
      setGlobalOpenDropdown(null);
    }
  };

  /**
   * Function to check if a specific dropdown should be open
   */
  const isDropdownOpen = (rowId: string, type: 'employee' | 'role' | 'shift'): boolean => {
    return globalOpenDropdown?.rowId === rowId && globalOpenDropdown?.type === type;
  };

  return {
    globalOpenDropdown,
    handleGlobalDropdownOpen,
    isDropdownOpen
  };
};